<template>
  <v-app app style="-webkit-app-region: drag">
    <v-content>
      <v-container class="scroll-y h-95" fluid>
        <v-layout align-center justify-center pt-4 pb-2 column fill-height>
          <v-layout align-center justify-center w-100 style="max-height: 45px;">
            <v-flex xs12 md7>
              <v-layout align-center justify-space-between row w-100>
                <v-flex xs5 md4 text-xs-left>
                  <v-btn
                      v-if="isBackAvailable"
                      flat
                      class="text-capitalize"
                      @click.prevent="back"
                  >
                    <v-icon class="v-icon--center d-flex pr-1" style="font-size: 14px;" dark small>
                      fa-solid fa-angle-left
                    </v-icon>
                    Back
                  </v-btn>
                </v-flex>
                <v-flex xs5 md4 text-xs-right>
                  <v-btn
                      v-if="$store.getters.ssShipperId"
                      flat
                      color="blue darken-2"
                      class="text-capitalize pr-4"
                      @click.prevent="handleSSLogout"
                  >
                    Logout
                    <v-icon class="v-icon--center d-flex pl-1" style="font-size: 14px;" dark small>
                      fa-solid fa-arrow-right-from-bracket
                    </v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout align-center justify-center class="w-100">
            <v-flex>
              <v-layout row align-center justify-center>
                <router-view></router-view>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>

import {logout} from '@/mixins/logout';

export default {
  name: 'LayoutAdmin',
  components: {

  },
  mixins: [logout],
  computed: {
    isBackAvailable() {
      return this.$route.name !== 'SSHome' && this.$route.name !== 'SSHomeHash' && this.$route.name !== 'SSShipper'
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
  },
}
</script>

<style scoped lang="stylus">

.h-95
  height 95%

</style>

<style lang="stylus">

::-webkit-scrollbar
  width 12px

::-webkit-scrollbar-track
  -webkit-box-shadow inset 0 0 6px rgba(0, 0, 0, 0.3)
  border-radius 10px

::-webkit-scrollbar-thumb
  border-radius 10px
  -webkit-box-shadow inset 0 0 6px rgba(0, 0, 0, 0.5)

</style>